import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-catalogue-model-info-modal',
  templateUrl: './catalogue-model-info-modal.component.html',
  styleUrl: './catalogue-model-info-modal.component.css'
})
export class CatalogueModelInfoModalComponent {

  catalogueConfig: any;
  selectedTabIndex: number = 0;
  modelInfoDetails: { value: string, label: string }[] = [];

  constructor(private _service: ServicecallService, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>) {
    this.catalogueConfig = this._service?.getConfiguration('catalogueConfig') ?? null;
    this.modelInfoDetails = this.catalogueConfig?.modelInfoDetails ?? null;
    this.modelInfoDetails = this.modelInfoDetails?.map(item => {
      switch (item?.label) {
        case 'Model Name':
          return { ...item, value: this.data?.routeData?.modelName ?? item?.value };
        default:
          return item;
      }
    });
  }

  /**
   * Tabs changed
   * @param event 
   */
  tabChanged(event: any) {
    this.selectedTabIndex = event?.index;
  }

  /**
   * Gets progress value
   * @param actualValue 
   * @param maxLimit 
   * @returns  
   */
  getProgressValue(actualValue: number, maxLimit: number) {
    return (actualValue / maxLimit) * 100
  }

}
